<div class="checkliste-container">
  <ng-container *ngFor="let key of dataSourceKeys">
    <ng-container
      [ngTemplateOutlet]="checklistTable"
      [ngTemplateOutletContext]="{
        dataSource: dataSource[key],
        tableFormArray: tableFormArray,
        title: getCategory(key)
      }"
    >
    </ng-container>
  </ng-container>
</div>

<ng-template #checklistTable let-tableFormArray="tableFormArray" let-dataSource="dataSource" let-title="title">
  <div class="checkliste-table-container">
    <form [formGroup]="tableFormArray">
      <table mat-table [dataSource]="dataSource" class="mat-elevation">
        <!-- description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>
            <h2>{{ title }}</h2>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.def.label }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['description']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['description']"></tr>
      </table>
    </form>
  </div>
</ng-template>
